var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#222528"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_13558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1875 40.9375C47.1875 41.7663 46.8583 42.5612 46.2722 43.1472C45.6862 43.7333 44.8913 44.0625 44.0625 44.0625H15.9375C15.1087 44.0625 14.3138 43.7333 13.7278 43.1472C13.1417 42.5612 12.8125 41.7663 12.8125 40.9375V23.75C12.8125 22.9212 13.1417 22.1263 13.7278 21.5403C14.3138 20.9542 15.1087 20.625 15.9375 20.625H22.1875L25.3125 15.9375H34.6875L37.8125 20.625H44.0625C44.8913 20.625 45.6862 20.9542 46.2722 21.5403C46.8583 22.1263 47.1875 22.9212 47.1875 23.75V40.9375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 37.8125C33.4518 37.8125 36.25 35.0143 36.25 31.5625C36.25 28.1107 33.4518 25.3125 30 25.3125C26.5482 25.3125 23.75 28.1107 23.75 31.5625C23.75 35.0143 26.5482 37.8125 30 37.8125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_13558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 37.5,
    fill: "white",
    transform: "translate(11.25 11.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0cbfa5cc35e5292724e7c6d3df5e2860.svg";
export { ForwardRef as ReactComponent };